import angular from 'angular';
import {DesignViewComponent} from './design-view.component';

export const designViewModule = angular.module('slViz.designView', [])
    .component('designView', DesignViewComponent)
    .name;



// WEBPACK FOOTER //
// ./src/js/views/design-view/index.js